import { render } from "./MainComparePriceBetweenProviders.vue?vue&type=template&id=6f94c9a6&scoped=true"
import script from "./MainComparePriceBetweenProviders.vue?vue&type=script&lang=js"
export * from "./MainComparePriceBetweenProviders.vue?vue&type=script&lang=js"

import "./MainComparePriceBetweenProviders.vue?vue&type=style&index=0&id=6f94c9a6&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f94c9a6"]])

export default __exports__